import { cin, ssn } from "swe-validation";
import { cvr } from "../cvr";
import mod11 from "../mod11";

export const validateNorwegianOrgNumber = (message: string) => {
    return (org_number: string) => {
        if (!org_number) {
            return;
        }
        if (org_number) {
            const trimmed = org_number.replace(/\s/g, "");
            const isDigits = /^\d+$/.test(trimmed);
            if (!isDigits) {
                return message;
            }
            try {
                const numbers = parseInt(trimmed).toString();
                if (
                    numbers.length === 9 &&
                    mod11(numbers) === parseInt(numbers.substr(8))
                ) {
                    return;
                }
            } catch {}
        }
        return message;
    };
};

const toDigits = (value: string) => {
    const trimmed = value.replace(/([\s|-])/g, "");
    const isDigits = /^\d+$/.test(trimmed);
    return isDigits ? trimmed : undefined;
};

export const validateSwedishOrgNumber = (message: string) => {
    // Allow regular company number and sole proprietorships
    return (org_number: string) => {
        if (!org_number) {
            return;
        }
        if (org_number) {
            const numbers = toDigits(org_number);
            if (!numbers) {
                return message;
            }
            try {
                // @ts-ignore - typings for the library are wrong, functions takes a string not a number
                const result = cin(numbers).isValid || ssn(numbers).isValid;
                if (result) {
                    return;
                }
            } catch {}
        }
        return message;
    };
};

export const validateDanishOrgNumber = (message: string) => {
    return (org_number: string) => {
        if (!org_number) {
            return;
        }
        if (org_number) {
            const numbers = toDigits(org_number);
            if (!numbers) {
                return message;
            }
            try {
                const result = cvr(numbers);
                if (result) {
                    return;
                }
            } catch {}
        }
        return message;
    };
};

export const validateFinnishOrgNumber = (message: string) => {
    return (org_number: string) => {
        if (!org_number) {
            return;
        }
        // Check if length is correct and the - is in the right place
        // Require the - to be present
        // The org number should be 7 digits, a hyphen and then one more digit
        const regex = /^\d{7}-\d{1}$/;
        if (!regex.test(org_number)) {
            return message;
        }
        const numbers = toDigits(org_number);
        if (!numbers) {
            return message;
        }
        try {
            // The last digit is a checksum digit
            const checkDigit = parseInt(numbers.charAt(numbers.length - 1), 10);
            const weights = [7, 9, 10, 5, 8, 4, 2];
            let sum = 0;
            for (let i = 0; i < weights.length; i++) {
                sum += parseInt(numbers.charAt(i), 10) * weights[i];
            }
            const remainder = sum % 11;
            let calculatedCheckDigit = 11 - remainder;
            if (calculatedCheckDigit === 11) {
                calculatedCheckDigit = 0;
            }
            if (
                calculatedCheckDigit === 10 ||
                calculatedCheckDigit !== checkDigit
            ) {
                return message;
            }
            return;
        } catch {}
        return message;
    };
};

export const getOrgNumberValidator = (
    country: string,
    errorMessage: string,
) => {
    if (country === "NO") {
        return validateNorwegianOrgNumber(errorMessage);
    } else if (country === "SE") {
        return validateSwedishOrgNumber(errorMessage);
    } else if (country === "DK") {
        return validateDanishOrgNumber(errorMessage);
    } else if (country === "FI") {
        return validateFinnishOrgNumber(errorMessage);
    }
    return (value: string) => {
        return undefined;
    };
};
